import { SoleboundFooter } from "./SoleboundFooter";
import { ProductCardProps } from "../../../types";
import { RevealLink } from "./RevealLink";
import TokenTransferModule from "./TokenTransferModule";
import OptimizelyFeatureFlaggedComponent from "@/src/components/OptimizelyFeatureFlaggedComponent";
import { OptimizelyFeatureFlags } from "@/src/services/optimizely/optimizelyFeatureFlags";

type FooterContent = ProductCardProps;

export function FooterContent(props: FooterContent) {
  if (props.isSolebound) {
    return <SoleboundFooter />;
  }

  return (
    <div className="min-w-0 flex-grow">
      <OptimizelyFeatureFlaggedComponent
        optimizelyFlags={[OptimizelyFeatureFlags.TOKEN_TRANSFER]}
        fallback={
          props.revealLink ? <RevealLink href={props.revealLink} /> : <></>
        }
      >
        <div className="flex flex-row gap-2 items-center">
          {props.revealLink && (
            <>
              <RevealLink href={props.revealLink} />
              <p className="text-gray-500 text-xs">|</p>
            </>
          )}

          {props.enabledTokenTransfer && (
            <TokenTransferModule
              swooshHandle={props.swooshHandle}
              collectionSlug={props.collectionSlug}
              token={{
                name: props.tokenName,
                id: props.tokenId,
                contractAddress: props.tokenContractAddress,
                image: { src: props.imageSrc, alt: props.imageAlt },
              }}
            />
          )}
        </div>
      </OptimizelyFeatureFlaggedComponent>
    </div>
  );
}
